import { createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "helpers/api_helper"
import { SEND_SENSITIVE_ACTION_OTP } from "helpers/sensitiveActionModules"

export const sendSensitiveActionOtp = createAsyncThunk(
  "sensitiveAction/sendOtp",
  async payload => {
    const response = await post(SEND_SENSITIVE_ACTION_OTP, payload)
    return response
  }
)
